import { TabList, TabPanel } from "@mui/lab";
import TabContext from "@mui/lab/TabContext";
import { Box, Tab } from "@mui/material";
import Activity from "components/common/activity";
import Attachment from "components/common/attachment";
import RightDrawer from "components/rightDrawer/RightDrawer";
import { useState } from "react";
import View from "./View";
import Comments from "./comment/Comments";
import { useEffect } from "react";
import useQueries from "hooks/useQueries";
import useApi from "hooks/useApi";

const ViewKnowledge = ({
  openDrawer,
  setOpenDrawer,
  currPost,
  setReload,
  statuses,

  permissions,
}) => {
  const { row_id, mod_id, setQueries } = useQueries();

  const [value, setValue] = useState( mod_id ||"1");
  const [profile, setProfile] = useState({});
  const { fetchData, loading } = useApi();

  const handleChange = (event, newValue) => {
    setQueries(`id=${row_id}&m=${newValue}`);

    setValue(newValue);
  };
  useEffect(() => {
    const getProfile = async () => {
      const endpoint = {
        method: "get",
        url: `/api/admin/knowledge/details/${row_id}`,
      };
      const { success, data } = await fetchData(endpoint, false);
      if (success) setProfile(data);
    };
    getProfile();
  }, []);
  return (
    <RightDrawer
      {...{
        openDrawer,
        setOpenDrawer,
        width: "900px",
        headingLeft: "#" + row_id + " - " + profile?.name,
        headingRight: "",
      }}
    >
      <Box sx={{ width: "100%", typography: "body1", overflowX: "hidden" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="View" value="1" />
              <Tab label="Comment" value="2" />
              <Tab label="Attachment" value="3" />
              <Tab label="Activity" value="4" />
            </TabList>
          </Box>
          <Box
            sx={{
              position: "relative",
              height: "calc(100vh - 114px)",
            }}
          >
            <TabPanel value="1">
              <View post={profile} loading={loading} />
            </TabPanel>
            <TabPanel value="2">
              <Comments post={profile} />
            </TabPanel>
            <TabPanel value="3">
              <Attachment id={row_id} route="knowledge" />
            </TabPanel>
            <TabPanel value="4">
              <Activity
                activityList={{
                  method: "get",
                  url: `/api/admin/knowledge/activity/${row_id}`,
                }}
              />
            </TabPanel>
          </Box>
        </TabContext>
      </Box>
    </RightDrawer>
  );
};

export default ViewKnowledge;
